/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { WellnessReminderCard } from "../../../components";
import { modalStorageKeys, WELLNESS_PLAN_STATUSES } from "../../../config/params";
import { useOverdueInvoiceStore } from "../../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import { IOverdueInvoiceOverallInfo } from "../../../state/pendingInvoices/pendingInvoices.reducer";
import { isDateWithinFiveDays } from "../../../utils/unix-timestamp";
import { useCombinedAlertsDataStore } from "../../../hooks";

const WellnessPlanReminderCardList = () => {
  const {
    endsSoonWPData,
    recentlyEndedWPData,
    failedRenewalsAfterGracePeriodWPData,
    failedRenewalsWPData,
  } = useCombinedAlertsDataStore();

  const { pendingPaymentPetList } = useOverdueInvoiceStore();

  const [paymentOverduePets, setPaymentOverduePets] = useState<IOverdueInvoiceOverallInfo[]>([]);

  useEffect(()=>{
    if (pendingPaymentPetList.length) {
      const filteredPetList = pendingPaymentPetList.filter((petData)=>{
        if ((petData.wellnessPlanPaymentStatus === WELLNESS_PLAN_STATUSES.LOCKED) || petData.wellnessPlanPaymentStatus === WELLNESS_PLAN_STATUSES.PAUSED) {
          return isDateWithinFiveDays(petData.endDate);
        }
      });

      filteredPetList.length > 0 && setPaymentOverduePets(filteredPetList);
    }
  }, [pendingPaymentPetList]);

  return (
    <div className="flex flex-col gap-2 ">
      {recentlyEndedWPData.length > 0 &&
        recentlyEndedWPData.map((petData, index) => (
          <WellnessReminderCard
            key={index}
            petName={petData.petName}
            petImage={petData?.petImage ?? undefined}
            planEndDate={petData.endDate}
            cardLastFourDigits = {petData.last4digit}
            reminderType={modalStorageKeys.nonAutoRenewEndedPlans}
            planOverdueStatus={WELLNESS_PLAN_STATUSES.CANCELLED}
          />
        ))}
      {endsSoonWPData.length > 0 &&
        endsSoonWPData.map((petData, index) => (
          <WellnessReminderCard
            key={index}
            petName={petData.petName}
            petImage={petData?.petImage ?? undefined}
            planEndDate={petData.endDate}
            cardLastFourDigits = {petData.last4digit}
            planName={petData.planName}
            reminderType={modalStorageKeys.wellnessPlansEndingSoon}
            planOverdueStatus={WELLNESS_PLAN_STATUSES.ACTIVE}
          />
        ))}
      {failedRenewalsWPData.length > 0 &&
        failedRenewalsWPData.map((petData, index) => (
          <WellnessReminderCard
            key={index}
            petName={petData.petName}
            petImage={petData?.petImage ?? undefined}
            planEndDate={petData.endDate}
            cardLastFourDigits = {petData.last4digit}
            reminderType={modalStorageKeys.autoRenewEndedPlans}
            planOverdueStatus={WELLNESS_PLAN_STATUSES.CANCELLED}
          />
        ))}
      {failedRenewalsAfterGracePeriodWPData.length > 0 &&
        failedRenewalsAfterGracePeriodWPData.map((petData, index) => (
          <WellnessReminderCard
            key={index}
            petName={petData.petName}
            petImage={petData?.petImage ?? undefined}
            planEndDate={petData.endDate}
            cardLastFourDigits = {petData.last4digit}
            reminderType={modalStorageKeys.autoRenewUnsuccessfulEndedPlans}
            planOverdueStatus={WELLNESS_PLAN_STATUSES.CANCELLED}
          />
        ))}
      {paymentOverduePets.length > 0 &&
        paymentOverduePets.map((petData, index) => (
          <WellnessReminderCard
            key={index}
            petName={petData.petName}
            petImage={petData.petImage ?? undefined}
            planEndDate={petData.endDate}
            reminderType={"paymentOverdueAlert"}
            planOverdueStatus={petData.wellnessPlanPaymentStatus || ""}
          />
        ))}
    </div>
  );
};

export default WellnessPlanReminderCardList;
